import { mergeStyles, useTheme } from '@fluentui/react';
import React, { useState } from 'react';
import { checkListStyles } from '../CheckList/CheckListStyles';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const DatePicker = require('react-mobile-datepicker');
import './MobileDatePicker.css';

const monthMap: Record<string, string> = {
  '1': 'Jan',
  '2': 'Feb',
  '3': 'Mar',
  '4': 'Apr',
  '5': 'May',
  '6': 'Jun',
  '7': 'Jul',
  '8': 'Aug',
  '9': 'Sep',
  '10': 'Oct',
  '11': 'Nov',
  '12': 'Dec',
};

const dateConfig = {
  year: {
    format: 'YYYY',
    caption: 'Year',
    step: 1,
  },
  month: {
    format: (value: Date) => monthMap[value.getMonth() + 1],
    caption: 'Mon',
    step: 1,
  },
  date: {
    format: 'DD',
    caption: 'Day',
    step: 1,
  },
};

export interface MobileDatePickerProps {
  onCancel?: () => void;
  onChange?: (date: Date) => void;
  onDone?: (date: Date) => void;
  defaultValue?: Date;
  placeholder?: string;
}

export const MobileDatePicker = (props: MobileDatePickerProps): JSX.Element => {
  const { onCancel, onChange, onDone, defaultValue, placeholder } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [dateValue, setDateValue] = useState<Date>();
  const [defaultDateValue, setDefaultDateValue] = useState<Date>(
    defaultValue || new Date()
  );

  const theme = useTheme();
  const stylesCheckList = checkListStyles(theme);

  const defaultOnCancel = () => {
    setIsOpen(false);
    onCancel && onCancel();
  };

  const defaultOnClick = () => {
    setIsOpen(true);
  };

  const defaultOnDone = (date: Date) => {
    setDateValue(date);
    setIsOpen(false);
    onDone && onDone(date);
    onChange && onChange(date);
  };

  const defaultOnChange = (date: Date) => {
    setDefaultDateValue(date);
    onChange && onChange(date);
  };

  const datePicker = (
    <DatePicker
      value={defaultDateValue}
      showCaption={false}
      isOpen={isOpen}
      theme="ios"
      confirmText="Done"
      cancelText="Cancel"
      customHeader={<span></span>}
      dateConfig={dateConfig}
      min={new Date(1900, 0, 1)}
      onSelect={defaultOnDone}
      onCancel={defaultOnCancel}
      onChange={defaultOnChange}
    />
  );

  return (
    <>
      <input
        readOnly
        type="text"
        value={
          dateValue
            ? dateValue.toLocaleDateString('en-US', {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
            })
            : ''
        }
        placeholder={placeholder}
        className={mergeStyles(stylesCheckList.inputField)}
        onClick={defaultOnClick}
      />
      {datePicker}
    </>
  );
};
